import React from 'react';

export default function ReadonlyLink(props) {
    return <span>{props.children}</span>
}